var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shopping-list"},[_c('h1',[_vm._v(_vm._s(_vm.intro))]),_vm._v(" "),_c('Menu'),_vm._v(" "),_c('ul',_vm._l((_vm.stock),function(item,index){return (item.current < item.target)?_c('li',{key:index},[_c('span',[_vm._v(_vm._s(item.name)+": "+_vm._s(item.target - item.current))])]):_vm._e()}),0)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e8000ab","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ShoppingList.vue
// module id = null
// module chunks = 